import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { StyledBtnSideBar } from './styles/StyledBtnSideBar';

class BtnSideBar extends Component {
  constructor(props) {
    super(props);

    this.handleOnClickBtn = this.handleOnClickBtn.bind(this);
  }

  handleOnClickBtn(e) {
    if (!this.props.enableClick) {
      e.preventDefault();
    }
  }

  render() {
    const {text, icon, isActive, position, linkTo, enableClick} = this.props;
    return (
      <StyledBtnSideBar
        isActive={isActive}
        enableClick={enableClick}
      >
        <Link to={linkTo} onClick={this.handleOnClickBtn} className="btn-sidebar-link">
          <div className="btn-sidebar-content">
            <div className="btn-sidebar-icon disable-select">
              <i className={'fa fa-' + icon} aria-hidden="true"></i>
            </div>
            <div className="btn-sidebar-step disable-select">
              { position + '. krok' }
            </div>
            <div className="btn-sidebar-title disable-select">
              { text }
            </div>
          </div>
        </Link>
      </StyledBtnSideBar>
    );
  }
}


BtnSideBar.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  position: PropTypes.number.isRequired,
  linkTo: PropTypes.string.isRequired,
  enableClick: PropTypes.bool.isRequired,
};


export default BtnSideBar;